import CurrencyInput from 'Components/Universal/Questionnaire/Fields/CurrencyInput';
import React from 'react';


const IncomeDetailsNetMonthlyIncomeSection = ({ id, isPrimary }) => {
  const name = isPrimary ? 'clientNetMonthlyIncome' : 'clientSecondaryNetMonthlyIncome';
  const answerKey = isPrimary ? 'clientNetMonthlyIncome' : 'clientSecondaryNetMonthlyIncome';
  return (
    <>
        Please input your net monthly income.
      <CurrencyInput
        name={`${name}.${id}`}
        answerKey={answerKey}
        placeholder="Net Monthly Income"
      />
      <br />
    </>
  );
};

export default IncomeDetailsNetMonthlyIncomeSection;
